import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {SalesAreaSearch} from "./SalesAreaSearch";

const vUI_Product_Group_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PRDGRP_ID:         {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center},
        domainOptions: {}},
    PRODUCT_GROUP_ID:     {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'PG Id', columnResourceName: 'colPGId', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_NAME:   {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    LEVEL_ID:             {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Level', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
        domainOptions: { domainIds: "ProductGroup_Level", useIdAsKey: true , maxLength: 50}},
    LEVEL_NAME:           {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Level Name', columnResourceName: 'colLevelNames', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    STATUS_CODE:          {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Status', columnResourceName: 'colStatus', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    SOURCE_ID:            {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Group Set ID', columnResourceName: 'colProductGroupSetID', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}},
    PLANNED_IND:          {
        type: SearchProviderFieldType.boolean,
        renderOptions: { columnName: 'Planned', columnResourceName: 'colPlanned', alignment: HorizAlignment.Center},
        domainOptions: { maxLength: 1}},
    TYPE_ID:              {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Type Id', columnResourceName: 'colTPMPrdGroupTypeId', alignment: HorizAlignment.Left},
        domainOptions: { domainIds: "ProductGroup_Type", useIdAsKey: true, maxLength: 50}},
    SUBTYPE_ID:           {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Sub Type Id', columnResourceName: 'colTPMPrdGroupSubTypeId', alignment: HorizAlignment.Left},
        domainOptions: { domainIds: "ProductGroup_SubType", useIdAsKey: true, maxLength: 50}},
    ALL_SALES_AREAS: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colPrdGrpSalesArea',      alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 256}
    },
    PRODUCT_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Type',   columnResourceName: 'colProductTypes',      alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Sales Area WB Id',  columnResourceName: 'colCustSARWBId', alignment: HorizAlignment.Center},
        domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}
    },
    WB_MDSET_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'MDSET ID', columnResourceName: 'colMDSetId', alignment: HorizAlignment.Center}, domainOptions: {}}

};

const vUI_Product_Group_Search_Product_Fields: {[id:string]: ISearchProviderField } = {
    WB_PRDGRP_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PRODUCT_GROUP_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID', columnResourceName: 'colProductGroupID', alignment: HorizAlignment.Left}, domainOptions: { domainIds: "ProductGroup_Level", useIdAsKey: true , maxLength: 50}},
    PRODUCT_GROUP_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group Name', columnResourceName: 'colProductGroupName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_ID_PRNT:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID Parent', columnResourceName: 'colProductGroupIdPrnt', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product ID', columnResourceName: 'colProductID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Name', columnResourceName: 'colProductName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
};

const vUI_Product_Group_Search_Error_Fields: {[id:string]: ISearchProviderField } = {
    WB_PRDGRP_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PRODUCT_GROUP_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID', columnResourceName: 'colProductGroupID', alignment: HorizAlignment.Left}, domainOptions: { domainIds: "ProductGroup_Level", useIdAsKey: true , maxLength: 50}},
    PRODUCT_GROUP_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group Name', columnResourceName: 'colProductGroupName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_ID_PRNT:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID Parent', columnResourceName: 'colProductGroupIdPrnt', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_START_DT:            {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_END_DT: {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    ERROR_REASON:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Error', columnResourceName: 'colErrorReason', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 1}},

};

const vUI_Product_Group_Search_Two_Parents: {[id:string]: ISearchProviderField } = {
    WB_PRDGRPR_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PRODUCT_GROUP_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID', columnResourceName: 'colProductGroupID', alignment: HorizAlignment.Left}, domainOptions: { domainIds: "ProductGroup_Level", useIdAsKey: true , maxLength: 50}},
    PRODUCT_GROUP_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group Name', columnResourceName: 'colProductGroupName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_START_DT:            {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_END_DT: {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},

};

const ProductGroupSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PRDGRP_ID',
        id_ui: 'PRODUCT_GROUP_ID',
        name:  'PRODUCT_GROUP_NAME'},


    searchProviderFields: vUI_Product_Group_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ProductGroup_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_PRDGRP_ID)
                    resolve(returnVals)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_ProductGroup_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


};


const ProductGroupSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ProductGroupSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',               searchProviderFieldId: 'PRODUCT_GROUP_ID',   renderOptions: { }},
        {profileFilterName: 'Name',             searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: { }},
        {profileFilterName: 'Level',            searchProviderFieldId: 'LEVEL_ID',        bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Type',             searchProviderFieldId: 'PRODUCT_TYPE',         bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Sales Area',       searchProviderFieldId: 'WB_SALESAREA_ID',   bMultiSelect: true, renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','LEVEL_ID','PRODUCT_TYPE','ALL_SALES_AREAS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductGroupSearchProviderBasic,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductGroupSearchProviderByProducts: ISearchProvider = {
    keyFields: {id: 'WB_PRDGRP_ID',
        id_ui: 'PRODUCT_GROUP_ID',
        name:  'PRODUCT_GROUP_NAME'},

    searchProviderFields: vUI_Product_Group_Search_Product_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ProductGroup_Search_ByProduct',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}

const ProductGroupSearchProviderErrorRecords: ISearchProvider = {

    keyFields: {id: 'WB_PRDGRP_ID',
        id_ui: 'PRODUCT_GROUP_ID',
        name:  'PRODUCT_GROUP_NAME'},


    searchProviderFields: vUI_Product_Group_Search_Error_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vWB_PrdGrpR_Dup',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

};

const ProductGroupSearchControlTwoParents: ISearchProvider =
    {
        keyFields: {id:    'WB_PRDGRP_ID',
            id_ui: 'PRODUCT_GROUP_ID',
            name:  'PRODUCT_GROUP_NAME'},


        searchProviderFields: vUI_Product_Group_Search_Two_Parents,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_CustomerControl_ProductGroup_TwoParents',
                    this.searchProviderFields,
                    [])

                findRequest.order = ['PRODUCT_GROUP_ID'];

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    };

const ProductGroupSearchProfileByProducts: ISearchProfile = {
    profileId: "ProductGroupSearchProfileByProducts",
    profileName: "Search by Products",
    renderOptions: { ui5ResourceId: "ProductGroupSearchProfileByProducts" },

    profileFilter: [
        {profileFilterName: 'Product Id',           searchProviderFieldId: 'PRODUCT_ID',   renderOptions: { }},
        {profileFilterName: 'Product Name',         searchProviderFieldId: 'PRODUCT_NAME', renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','PRODUCT_GROUP_ID_PRNT','PRODUCT_ID','PRODUCT_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductGroupSearchProviderByProducts,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductGroupSearchProfileByErrorRecords: ISearchProfile = {
    profileId: "ProductGroupSearchProfileByErrorRecords",
    profileName: "Error Records",
    renderOptions: { ui5ResourceId: "ProductGroupSearchProfileByErrorRecords" },

    profileFilter: [
        {profileFilterName: 'Id',           searchProviderFieldId: 'PRODUCT_GROUP_ID',   renderOptions: { }},
        {profileFilterName: 'Name',         searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','PRODUCT_GROUP_ID_PRNT','EFFECTIVE_START_DT','EFFECTIVE_END_DT','ERROR_REASON'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductGroupSearchProviderErrorRecords,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductGroupSearchTwoParents: ISearchProfile = {
    profileId: 'ControlProductGroup',
    profileName: "Control Two Parents ProductGroup",
    renderOptions: { ui5ResourceId: "ProductGroupSearchTwoParents"},

    profileFilter: [
        {profileFilterName: 'Product Condition',     searchProviderFieldId: 'PROD_CND_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','EFFECTIVE_START_DT', 'EFFECTIVE_END_DT'  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductGroupSearchControlTwoParents,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};
/*
var ProductGroupSearchProfileBySource: ISearchProfile = {
    profileId: "default",
    profileName: "Search by ProductGroupType",
    renderOptions: { ui5ResourceId: "ProductGroupSearchProfileByProductGroupType" },

    profileFilter: [
        {profileFilterName: 'ProductGroupTypeID',     searchProviderFieldId: 'ProductGroup_TYPE_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'ProductGroup_ID','ProductGroup_NAME','ProductGroup_SORT_ID','TPM_ProductGroup_ROW_ID','SOURCE_ID','ProductGroup_TYPE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductGroupSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}
*/

const ProductGroupSearch: ISearch = {
    searchName: "Find ProductGroup",
    renderOptions: { ui5ResourceId: "ProductGroupSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ProductGroupSearchProfileByName, ProductGroupSearchProfileByProducts, ProductGroupSearchProfileByErrorRecords,ProductGroupSearchTwoParents]
};
PAEnvironment.registerBusinessObjectSearch("ProductGroupBO", "ProductGroup", ProductGroupSearch, "Product Group Search")

export {ProductGroupSearch}